// extracted by mini-css-extract-plugin
module.exports = {"partnerPricingBannerRoot":"partner-pricing-banner_partnerPricingBannerRoot__T_XUZ","promotionText":"partner-pricing-banner_promotionText__QWb4_"};